<div class="page-container case-management-container container">
  <div class="case-management-detail-container">
    <app-breadcrumb [crumbConfig]="crumbConfig" />

    @if (!loading && !editCaseTitle) {
      <h1 class="header col-12 mb-1">
        {{ caseProfile['CaseManagement']['Title'] }}
        <button
          mat-icon-button
          [matTooltip]="'Edit case title'"
          (click)="toggleEditCaseTitle(true)"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </h1>
    }
    @if (!loading && editCaseTitle) {
      <div class="edit-title-container mb-3">
        <mat-form-field class="mb-0 w-50">
          <mat-label>Case Title</mat-label>
          <input
            type="text"
            matInput
            name="caseTitle"
            [placeholder]="'Case Title'"
            [(ngModel)]="caseTitle"
          />
        </mat-form-field>
        <button
          color="warn"
          mat-icon-button
          [matTooltip]="'Cancel'"
          (click)="cancelEditCaseTitle()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <button
          color="primary"
          mat-icon-button
          [matTooltip]="'Save case title'"
          (click)="saveCaseTitle()"
        >
          <mat-icon>save</mat-icon>
        </button>
      </div>
    }

    @if (!loading) {
      <div class="actions-container mb-3">
        <button mat-button color="primary" (click)="nav('case-management')">
          <mat-icon>arrow_back_ios</mat-icon> Back to Case Management
        </button>
        @if (
          caseProfileID && caseProfile?.['UnitCMSettings']?.['OpenCaseSummary']
        ) {
          <button mat-button color="primary" (click)="nav('caseSummary')">
            <mat-icon>checklist</mat-icon> Open Case Summary
          </button>
        }
      </div>

      <div class="trade-info-container info-card expanded mb-4 w-100 p-0">
        <div class="card-header">
          <span class="card-title-container">
            Case Management Number:
            <span class="card-title mb-0 ms-2">{{ CRID }}</span>
          </span>
          <div class="action-btns-container">
            <span class="me-1">
              <div class="save-case-container pull-right">
                @if (
                  !loading &&
                  caseProfile['UnitCMPostBack'] &&
                  caseProfile['UnitCMPostBack']['ShowPostBackButton'] &&
                  caseProfile['UnitCMPostbackStatus'] &&
                  caseProfile['UnitCMPostbackStatus']['ShowStatuses'].includes(
                    caseDetails['StatusID'].toString()
                  )
                ) {
                  <button
                    mat-raised-button
                    aria-label="Submit Note"
                    color="accent"
                    (click)="submitPostback()"
                  >
                    <mat-icon>assignment_turned_in</mat-icon>
                    {{ caseProfile['UnitCMPostBack']['PostBackButtonLabel'] }}
                  </button>
                }
              </div>
            </span>
            <button
              mat-raised-button
              aria-label="Save"
              color="accent"
              [disabled]="saveBtnDisabled()"
              (click)="saveCaseChanges()"
            >
              @if (
                !(
                  canRespondToAssignee &&
                  this.caseProfile?.CaseManagement?.AssignedTo !==
                    this.profileID
                )
              ) {
                <mat-icon>save</mat-icon>
              }
              @if (
                canRespondToAssignee &&
                this.caseProfile?.CaseManagement?.AssignedTo === this.profileID
              ) {
                Save Changes and Respond to Assignee
              } @else if (
                canRespondToAssignee &&
                this.caseProfile?.CaseManagement?.AssignedTo !== this.profileID
              ) {
                Assigned to Reviewer. Please wait for Reviewer to Reassign.
              } @else {
                Save Changes
              }
            </button>
          </div>
        </div>
        <div class="card-info row pt-3">
          <div class="col-sm-3 col-12">
            <div class="card-info-label text-with-icon">
              Submitted By
              @if (isCaseManager) {
                <mat-icon
                  matTooltip="Submitted by this user"
                  aria-label="Icon that displays a tooltip when focused or hovered over"
                  class="submitted-by-icon"
                  >attribution</mat-icon
                >
              }
            </div>
            @if (caseHistoryData && caseHistoryData[0]) {
              <div class="card-info-value">
                {{ caseHistoryData[0]['SavedByName'] }}
              </div>
            }
          </div>
          <div class="col-sm-3 col-12">
            <div class="card-info-value">
              @if (canRespondToAssignee) {
                <div class="card-info-label"> Assigned To </div>
                {{ caseProfile['CaseManagement']['AssignedTo'] }}
              } @else if (!canRespondToAssignee) {
                <mat-form-field class="assigned-to-field">
                  <mat-label>Assigned To</mat-label>
                  <input
                    type="text"
                    placeholder="Assigned To"
                    aria-label="Assigned To"
                    matInput
                    [formControl]="assignedToCtrl"
                    [matAutocomplete]="auto"
                    [disabled]="canRespondToAssignee"
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    [displayWith]="displayAssigned"
                    (optionSelected)="changeAssigned($event)"
                  >
                    @for (option of filteredAssignedToOptions; track option) {
                      <mat-option [value]="option">
                        <div class="text-with-icon">
                          {{ option.UserName || option.UserID }}
                          @if (submittedBy === option.UserID && isCaseManager) {
                            <mat-icon
                              matTooltip="Submitted by this user"
                              aria-label="Icon that displays a tooltip when focused or hovered over"
                              class="submitted-by-icon"
                              >attribution</mat-icon
                            >
                          } @else if (
                            mostRecentUpdateReviewerItem &&
                            mostRecentUpdateReviewerItem.AssignedTo ===
                              option.UserID &&
                            !isCaseManager
                          ) {
                            <mat-icon
                              matTooltip="Last assigned reviewer"
                              aria-label="Icon that displays a tooltip when focused or hovered over"
                              class="submitted-by-icon"
                              >supervisor_account</mat-icon
                            >
                          }
                        </div>
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              }
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div
              class="card-info-value status-info"
              [ngClass]="{
                'status-readonly': canRespondToAssignee,
                'status-edit': !canRespondToAssignee,
              }"
            >
              @if (canRespondToAssignee) {
                <div class="card-info-label"> Case Status </div>
                {{ caseProfile['CaseManagement']['StatusName'] }}
              } @else if (!canRespondToAssignee) {
                <mat-form-field class="case-status-field">
                  <mat-label>Case Status</mat-label>
                  <mat-select
                    [(ngModel)]="caseProfile['CaseManagement']['StatusID']"
                    (selectionChange)="changeStatus()"
                  >
                    @for (
                      status of caseProfile['ActiveStatuses'];
                      track status.StatusID
                    ) {
                      <mat-option
                        [value]="status.StatusID"
                        [disabled]="!status['Active']"
                      >
                        {{ status.StatusName || status.StatusID }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (
                  caseProfile['CaseManagement']['StatusID'] &&
                  caseStatusChangeReasons &&
                  caseStatusChangeReasons.length > 0
                ) {
                  <mat-form-field class="status-info-reasons-field">
                    <mat-label>Reason(s)</mat-label>
                    <mat-select
                      multiple
                      [formControl]="statusReasonsCtrl"
                      (selectionChange)="statusReasonsChange($event.value)"
                    >
                      @for (reason of caseStatusChangeReasons; track reason) {
                        @if (
                          reason.StatusID ===
                          caseProfile['CaseManagement']['StatusID']
                        ) {
                          <mat-option [value]="reason.Reason">{{
                            reason.Reason
                          }}</mat-option>
                        }
                      }
                    </mat-select>
                  </mat-form-field>
                }
              }
            </div>
          </div>
        </div>
      </div>

      @if (aiSummaryTool && aiSummaryText) {
        <div
          class="trade-info-container info-card ai-summary-card expanded mb-4 w-100 p-0"
        >
          <div class="card-header">
            <span class="card-title mb-0">AI Case Summary</span>
            <span class="toggle-arrow">
              <button
                mat-icon-button
                (click)="expand($event, 'ai-summary-card')"
                ><mat-icon>expand_circle_down</mat-icon></button
              >
            </span>
          </div>
          <div class="card-info row">
            <app-ai-summary
              class="ai-summary-card-content col-12"
              [title]="false"
              [text]="aiSummaryText"
            />
          </div>
        </div>
      }

      @if (caseDescription) {
        <div class="info-card expanded w-100 mb-4">
          <div class="trade-info-container info-card expanded mb-4 p-0">
            <div class="card-header">
              <span class="card-title mb-0">Case Description</span>
            </div>
            <div class="case-description">
              <div class="px-2">
                @if (editMessageId !== caseDescription.NoteId) {
                  <span
                    [innerHTML]="parseCaseDescription(caseDescription.NoteText)"
                  ></span>
                  @if (caseDescriptionIds.length > 1) {
                    <mat-form-field>
                      <mat-label>
                        {{ recordType(caseDescription.NoteText) }}
                      </mat-label>
                      <mat-select
                        panelWidth="null"
                        [formControl]="recordSelect"
                      >
                        @for (recordId of caseDescriptionIds; track recordId) {
                          <mat-option
                            [value]="
                              recordType(
                                caseDescription.NoteText
                              ).toLowerCase() +
                              '-review/' +
                              recordId
                            "
                          >
                            {{ recordId }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    @if (this.rights.includes('PostTrade')) {
                      <button
                        mat-raised-button
                        color="accent"
                        [disabled]="!recordSelect.value"
                        (click)="nav(recordSelect.value)"
                      >
                        <mat-icon>visibility</mat-icon> View
                        {{ recordType(caseDescription.NoteText) }}
                      </button>
                    }
                  } @else if (caseDescriptionIds.length === 1) {
                    @for (recordId of caseDescriptionIds; track recordId) {
                      <span>
                        <strong>
                          {{ recordType(caseDescription.NoteText) }}:
                        </strong>
                        <button
                          mat-button
                          color="primary"
                          [disabled]="!this.rights.includes('PostTrade')"
                          (click)="
                            nav(
                              recordType(
                                caseDescription.NoteText
                              ).toLowerCase() +
                                '-review/' +
                                recordId
                            )
                          "
                        >
                          {{ recordId }}
                        </button>
                        <br />
                      </span>
                    }
                  }
                } @else {
                  <textarea
                    name="Case Description Input"
                    matInput
                    rows="8"
                    [(ngModel)]="editMessage"
                  ></textarea>
                }
              </div>
            </div>
          </div>
        </div>
      }

      <div class="half-card-container">
        <div class="info-card expanded w-33 mb-4">
          <div class="card-header">
            <span class="card-title mb-0"> Case Files </span>
          </div>

          <div class="card-details case-files">
            <div class="details">
              @if (canUploadFiles) {
                <div class="upload-case-files mb-2">
                  <h4 class="mb-2">Upload Files</h4>
                  <input
                    #fileUpload
                    type="file"
                    class="file-input"
                    (change)="onFileSelected($event)"
                  />
                  <span class="mb-2">
                    {{ fileName || 'No file selected yet' }}
                  </span>
                  @if (fileName) {
                    <button
                      class="w-100 mb-3"
                      mat-stroked-button
                      aria-label="Choose a Different File"
                      color="warn"
                      (click)="fileUpload.click()"
                    >
                      <mat-icon>upload</mat-icon> Choose a Different File
                    </button>
                    <button
                      class="w-100 mb-3"
                      mat-raised-button
                      aria-label="Complete Upload"
                      color="primary"
                      (click)="completeFileUpload()"
                    >
                      <mat-icon>check</mat-icon> Complete Upload
                    </button>
                  }
                </div>
              }
              <div
                class="case-files list"
                [ngClass]="{ 'no-upload': !canUploadFiles }"
              >
                <div class="attached-files-title">
                  <h4 class="mb-2">
                    Attached Files
                    <small>({{ caseFiles ? caseFiles.length : 0 }})</small>
                  </h4>
                  @if (showPrintReportBtn && isCaseManager) {
                    <div class="mb-2">
                      <button
                        mat-raised-button
                        color="primary"
                        (click)="printCMReport($event)"
                      >
                        {{ reportSettings['ButtonText'] }}
                      </button>
                    </div>
                  }
                </div>
                <div class="attached-case-files">
                  @if (filesLoading) {
                    <div>LOADING FILES...</div>
                  } @else {
                    @if (!caseFiles || caseFiles.length === 0) {
                      <div class="ps-1">No Files Found.</div>
                    } @else {
                      @for (caseFile of caseFiles; track caseFile) {
                        <div class="download-row">
                          <span> {{ caseFile.Name }} </span>
                          <button
                            class="ms-2"
                            mat-icon-button
                            color="primary"
                            matTooltip="Download File"
                            (click)="getCaseRecordFile(caseFile)"
                          >
                            <mat-icon>download</mat-icon>
                          </button>
                          @if (caseFile.Type.toLowerCase() === 'pdf') {
                            <button
                              class="ms-2"
                              mat-icon-button
                              color="primary"
                              matTooltip="View File"
                              (click)="loadFileIntoViewer(caseFile)"
                            >
                              <mat-icon>visibility</mat-icon>
                            </button>
                          }
                          @if (
                            caseFile.Category !== 'System' && canDeleteFiles
                          ) {
                            <button
                              class="ms-2"
                              mat-icon-button
                              color="warn"
                              aria-label="Delete Case File"
                              matTooltip="Delete File"
                              (click)="deleteCaseRecordFile(caseFile)"
                            >
                              <mat-icon>delete</mat-icon>
                            </button>
                          }
                        </div>
                      }
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="info-card expanded w-66 chat-messages-card mb-4">
          <div class="card-header">
            <span class="card-title mb-0"> Notes </span>
          </div>
          <div class="card-details details-notes">
            <div class="details">
              <div class="chat-center">
                <div class="chat-messages-container">
                  @if (messageListCheck()) {
                    <div class="message-container w-100">
                      @for (
                        message of messages;
                        track message.NoteId;
                        let i = $index
                      ) {
                        <div
                          class="chat-message"
                          [ngClass]="{
                            incoming:
                              message.CreatedByUserId !== defaultUser.id,
                            'type-two':
                              message.NoteTypeId === '2' ||
                              message.NoteTypeId === 2,
                            hidden:
                              ((message.NoteTypeId === '2' ||
                                message.NoteTypeId === 2) &&
                                !isCaseManager) ||
                              message.NoteTypeId === 3 ||
                              message.NoteTypeId === '3',
                            'top-message': i === 0,
                          }"
                        >
                          <div class="sender-info">
                            {{
                              message.CreatedByUserName ||
                                message.CreatedByUserId
                            }}
                            at
                            {{ message.CreateDate | date: 'medium' }}
                          </div>
                          @if (
                            message.NoteTypeId === '2' ||
                            message.NoteTypeId === 2
                          ) {
                            <div class="sender-info">Private</div>
                          }
                          @if (editMessageId !== message.NoteId) {
                            <div class="chat-bubble mb-3">
                              <span [innerHTML]="message.NoteText"></span>
                              @if (allowEditing) {
                                <span class="edit-icon-container">
                                  <mat-icon
                                    class="edit-icon"
                                    (click)="editNote(message)"
                                  >
                                    edit_note
                                  </mat-icon>
                                </span>
                              }
                            </div>
                          } @else {
                            <div class="edit-bubble">
                              @if (isCaseManager) {
                                <mat-form-field class="w-20 me-1">
                                  <mat-label>Type</mat-label>
                                  <mat-select [(ngModel)]="editNoteType">
                                    @for (type of noteTypes; track type.value) {
                                      <mat-option [value]="type.value">
                                        {{ type.label }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              }
                              <div class="input-container">
                                <div class="input-editor w-100">
                                  <ngx-editor-menu
                                    [editor]="submittedEditor"
                                    [toolbar]="toolbar"
                                  />
                                  <ngx-editor
                                    [editor]="submittedEditor"
                                    [disabled]="false"
                                    [placeholder]="'Message'"
                                    [ngModelOptions]="{ standalone: true }"
                                    [(ngModel)]="editMessage"
                                  />
                                </div>
                              </div>
                              <mat-icon (click)="submitEdit()">save</mat-icon>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="no-chat-container"> No messages found </div>
                  }
                </div>
                <div class="chat-input">
                  <form (submit)="submitNote()">
                    <div class="w-20 me-1 note-configuration-container">
                      @if (rights.includes('CaseManager')) {
                        <mat-form-field>
                          <mat-label>Type</mat-label>
                          <mat-select [(value)]="noteType">
                            @for (type of noteTypes; track $index) {
                              <mat-option [value]="type.value">
                                {{ type.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }

                      @if (cannedResponses && cannedResponses.length > 0) {
                        <button
                          #cannedResponseMenuTrigger
                          class="mt-2"
                          mat-raised-button
                          color="primary"
                          [matMenuTriggerFor]="cannedResponseMenu"
                          (click)="$event.preventDefault()"
                        >
                          <mat-icon>try</mat-icon> Canned Responses
                        </button>
                        <mat-menu
                          #cannedResponseMenu="matMenu"
                          class="canned-response-menu"
                        >
                          @for (
                            group of cannedResponses;
                            track group;
                            let i = $index
                          ) {
                            <span class="group-heading">{{
                              group.AlertID
                            }}</span>
                            @for (
                              cannedResp of group.Responses;
                              track cannedResp
                            ) {
                              <button
                                mat-menu-item
                                [matTooltip]="cannedResp"
                                [matTooltipPosition]="'right'"
                                (click)="
                                  selectCannedResponse($event, cannedResp)
                                "
                              >
                                {{ cannedResp.slice(0, 80) + '...' }}
                              </button>
                            }
                            @if (i !== cannedResponses.length - 1) {
                              <mat-divider />
                            }
                          }
                        </mat-menu>
                      }
                    </div>
                    <div class="input-container">
                      <div class="input-items">
                        <div class="input-editor">
                          <ngx-editor-menu
                            [editor]="editor"
                            [toolbar]="toolbar"
                          />
                          <ngx-editor
                            [editor]="editor"
                            [disabled]="false"
                            [placeholder]="'Message'"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="message"
                            (keyup)="updateTypedText($event)"
                          />
                          @if (allowEditing) {
                            <div
                              class="note-hint"
                              [ngClass]="{ 'note-hint-manager': isCaseManager }"
                            >
                              *Note can be edited at any time after it is sent
                            </div>
                          }
                        </div>
                        @if (canSpeechToText) {
                          <app-speech-to-text
                            [speechReviewed]="voiceReviewed"
                            [typedText]="typedText"
                            [externalTriggerStop]="externalTriggerStop"
                            (text)="applySpeechToTextNote($event)"
                            (noteSpeechError)="applySpeechToTextError($event)"
                          />
                        }
                        <button
                          class="mx-2"
                          mat-mini-fab
                          aria-label="Submit Note"
                          color="primary"
                          type="submit"
                          [disabled]="
                            !message ||
                            message === '<p></p>' ||
                            (usedVoice && !voiceReviewed)
                          "
                        >
                          <mat-icon>send</mat-icon>
                        </button>
                      </div>
                      @if (usedVoice) {
                        <div class="voice-review-container">
                          <div class="checkbox-content-container">
                            <mat-checkbox
                              [checked]="voiceReviewed"
                              (change)="speechReviewEvent($event)"
                              >I have reviewed and confirmed the accuracy of
                              this note, including any speech-to-text
                              dictation.</mat-checkbox
                            >
                          </div>
                        </div>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (pdfBase64) {
        <div
          class="trade-info-container info-card pdf-viewer-container expanded mb-4 w-100 p-0"
          [ngClass]="{
            'pdf-viewer-container-hidden': !pdfBase64,
            'pdf-viewer-container-shown': pdfBase64,
          }"
        >
          <div class="card-header">
            <span class="card-title-container">
              Report:
              <span class="card-title mb-0 ms-2">{{ activeCaseFile }}</span>
            </span>
            <span class="toggle-arrow">
              <button
                mat-icon-button
                (click)="expand($event, 'pdf-viewer-container')"
                ><mat-icon>expand_circle_down</mat-icon></button
              >
            </span>
          </div>
          <div class="card-info">
            @if (pdfBase64) {
              <kendo-pdfviewer
                style="height: 85vh"
                [data]="pdfBase64"
                [tools]="pdfViewerTools"
              />
            }
          </div>
        </div>
      }
      @if (showCaseHistory) {
        <div class="mutual-funds-container info-card expanded mb-4 w-100 p-0">
          <div class="card-header">
            <span class="card-title mb-0"> Case History </span>
          </div>
          <div class="case-history-table">
            <table class="details col-12">
              <thead>
                @for (header of caseHistoryHeaders; track header.label) {
                  <th>{{ header.label }}</th>
                }
              </thead>
              <tbody>
                @for (entry of caseHistoryData; track entry) {
                  <tr>
                    @for (header of caseHistoryHeaders; track header.label) {
                      <td>{{
                        arrDeclaration.isArray(entry[header.fieldName])
                          ? entry[header.fieldName].join(', ')
                          : entry[header.fieldName]
                      }}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    }
    <ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: false }" />
  </div>
</div>
